import styled, { css } from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FormContainer = styled.div`
    flex-direction: column;
`;

export const AboveFieldContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const fieldContainerCommonStyles = css`
    cursor: pointer;
    transition: border 0.24s ease-in-out;
    margin-bottom: 5px;
    outline: none;

    :focus {
        border-color: ${({ theme }) => theme.palette.primary.main};
    }
`;

export const ExistingFieldContainer = styled.div`
    ${fieldContainerCommonStyles};
`;

export const EmptyFieldContainer = styled.div`
    ${fieldContainerCommonStyles};
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 28px 30px;
    border-radius: 4px;
    border: 2px dashed ${({ theme }) => theme.palette.grey[200]};
    background-color: ${({ theme }) => theme.palette.grey[100]};
`;
